import { useSelector } from 'react-redux';

import {
  type UseAssetLocationBreadcrumbsOptions,
  useAssetLocationBreadcrumbItems,
} from '~/components/AssetModalV2/hooks/useAssetLocationBreadcrumbItems';
import { centralizedPublicClipBoardInfoSelector } from '~/store/centralizedClip/selectors';

/** Public board and showcase asset modals: crumbs come from the URL board, not clip membership. */
export const usePublicAssetLocationBreadcrumbs = ({
  onBoardClick,
  excludeLibrary,
}: UseAssetLocationBreadcrumbsOptions) => {
  const { current } = useSelector(centralizedPublicClipBoardInfoSelector);

  return useAssetLocationBreadcrumbItems({ current, excludeLibrary, onBoardClick });
};
